let elementName = `nss-animated-number`;
if (typeof customElements.get(elementName) === `undefined`) {
  class NSSAnimatedNumber extends HTMLElement {
    constructor() {
      super();

      this.debug = false;
      this.formatter = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });
      this.tick = 40;
    }

    connectedCallback() {
      if (this.debug) console.log("[NSS][Animated Number] Connected.");

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        if (this.debug) console.log("[NSS][Animated Number] Observed!");

        const target = this.getAttribute(`nss-animated-number`);
        this.startAnimation(this.querySelector(`[nss-animated-number-d]`), target);
        this.startAnimation(this.querySelector(`[nss-animated-number-m]`), target);
      };

      const observer = new IntersectionObserver(handleIntersection, {
        rootMargin: "-200px 0px -200px 0px",
      });
      observer.observe(this);
    }

    roundToTwo(num) {
      return +(Math.round(num + "e+2") + "e-2");
    }

    startAnimation(element, endValue) {
      if (!element) return;

      let currentValue = 0;
      let step;
      if (endValue % 1 === 0) {
        step = Math.ceil(endValue / 100);
      } else {
        step = endValue / 100.0;
      }
      const interval = setInterval(() => {
        if (currentValue + step >= endValue) {
          currentValue = endValue;
          clearInterval(interval);
        } else {
          currentValue += step;
        }
        element.textContent = Math.round(currentValue * 10) / 10;
      }, this.tick);
    }
  }

  customElements.define(elementName, NSSAnimatedNumber);
} else {
  console.warn(`[NSS] Element '${elementName}' already defined.`);
}
